import { ExtendedHighlight } from './highlight'

export * from './highlight'

export default ExtendedHighlight